import { RentForm } from 'components/forms';

const PropertiesRent = () => (
  <RentForm />
);

export default PropertiesRent;